module.exports = __webpack_public_path__ + "static/media/trip.275400c4.ico";